/**
 * Item price helpers.
 * `selling_price` is the regular price.
 * `sale_price`, when present and lower than selling_price, is the active discount.
 */

export function isOnSale(item) {
    if (!item) return false;
    const sp = Number(item.sale_price);
    const reg = Number(item.selling_price || 0);
    return Number.isFinite(sp) && sp > 0 && sp < reg;
}

export function effectivePrice(item) {
    return isOnSale(item) ? Number(item.sale_price) : Number(item.selling_price || 0);
}

export function discountPct(item) {
    if (!isOnSale(item)) return 0;
    const reg = Number(item.selling_price);
    return Math.round(((reg - Number(item.sale_price)) / reg) * 100);
}
